export default {
  apiKey: "AIzaSyAQOp5Oet9gCDn2qPFJ9ztvz6mOtEGEqt4",
  discoveryDocs: 
    ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  spreadsheetId: "1L5feut3O9zyAhJS6TMei7YrqepXUcKVn8OKx5dyn7kc"
};